import some from 'lodash/some';
import { gettext } from '@eb/i18n-ebspa';

export const getTrendingSearchesPathForLocation = (slug) =>
    `/trending/searches/${slug}/`;

const _isTrendingSearchCity = (trendingSearchCities, domain, slug) =>
    some(
        trendingSearchCities,
        (trendingSearchCity) => trendingSearchCity[1] === slug,
    );

export const getTrendingSearchData = (
    { slug, currentPlace, currentPlaceParent, trendingSearchCities },
    domain,
    shouldShowTrendingSearchPageLink,
) => {
    let trendingSearchData = null;

    // TODO: remove the second check after shouldShowTrendingSearchPageLink is in context data
    // https://jira.evbhome.com/browse/EB-134447
    if (
        shouldShowTrendingSearchPageLink ||
        (shouldShowTrendingSearchPageLink === null &&
            _isTrendingSearchCity(trendingSearchCities, domain, slug))
    ) {
        let trendSearchText = gettext('Trending searches in %(city)s', {
            city: currentPlace,
        });

        if (currentPlaceParent) {
            trendSearchText = gettext(
                'Trending searches in %(city)s, %(region)s',
                {
                    city: currentPlace,
                    region: currentPlaceParent,
                },
            );
        }

        trendingSearchData = {
            text: trendSearchText,
            path: getTrendingSearchesPathForLocation(slug),
        };
    }

    return trendingSearchData;
};
